module.exports = __webpack_public_path__ + "img/logo-on-dark.46872f77.png";